// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdChartsRevenuePreviousWindowResult = objectOf({
  daily_revenue: arrayOf(arrayOf(number)),
  daily_purchases: arrayOf(arrayOf(number)),
  daily_dau: arrayOf(arrayOf(number)),
});
